export type JobDetailsState = 'ready' | 'loading' | 'missing';

/**
 * Wie die Detailansicht mit einem Auftrag umgeht, der nicht im Store liegt (#336).
 *
 * `missing` gilt erst, wenn ein Ladedurchlauf über **alle** angemeldeten Zugänge abgeschlossen ist
 * und gerade keiner läuft. Sonst wäre ein Deep-Link vor dem ersten Laden nicht von einem
 * serverseitig stornierten Auftrag zu unterscheiden — und ein nachträglich angemeldeter zweiter
 * Zugang könnte den Auftrag noch mitbringen.
 */
export const resolveJobDetailsState = ({
    hasJob,
    hasLoadedJobs,
    isRefreshing,
}: {
    hasJob: boolean;
    hasLoadedJobs: boolean;
    isRefreshing: boolean;
}): JobDetailsState => {
    if (hasJob) {
        return 'ready';
    }
    if (!hasLoadedJobs || isRefreshing) {
        return 'loading';
    }

    return 'missing';
};
